const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');

module.exports = class IncludedValueSearch extends Builder {
    constructor(title, properties) {
        super('searchElement_IncludedValueSearch', title, properties);
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
